export function createConfigContext (auth, price) {
  return {
    isCustomerList: price.CustomerId > 0,
    isShopList: price.CustomerId === 0 && price.ShopId > 0,
    isChainList: price.CustomerId === 0 && price.ShopId === 0 && price.ChainId > 0,
    isCustomerUser: auth.user.UserType === 4,
    isShopUser: auth.user.UserType === 5 || auth.user.UserType === 3 || auth.user.UserType === 7,
    isChainUser: auth.user.UserType === 2,
    isWorkProviderUser: auth.user.UserType === 6,
    isSuperUser: auth.user.UserType === 1,
    department: price.Department,
    useRecommended: price.UseRecommended,
    onlyShow: (auth.user.UserType === 1 || auth.user.UserType === 6) && price.UseRecommended
  }
}

export function getServicesConfig (context) {
  return {
    itemIdField: 'ServiceTaskId',
    itemOrderField: 'SortIndex',
    editable: true, // context.isCustomerUser && !context.useRecommended,
    whitebox: true,
    draggable: true,
    title: 13375,
    titleHelp: context.isCustomerUser ? 1942 : undefined,
    groupCss: null,
    allowAdd: true,
    allowDelete: true,
    groupField: 'IsExtra',
    fields: [
      {
        name: 'Name',
        header: 1203,
        type: 'text',
        editable: false,
        hide: false,
        css: 'taskName',
        col: 3
      },
      {
        name: 'Price',
        header: 641,
        type: 'currency',
        editable: false,
        hide: false,
        css: 'price'
      },
      {
        name: 'Discount',
        type: 'percent',
        editable: false,
        hide: true,
        css: 'discount'
      },
      {
        name: 'Net',
        type: 'currency',
        editable: false,
        hide: true,
        css: 'net'
      }
    ],
    newItemInputs: ['Name', 'Price']
  }
}

export function getExtrasConfig (context) {
  return {
    itemIdField: 'ServiceTaskId',
    itemOrderField: 'SortIndex',
    editable: !context.isCustomerUser && !context.useRecommended,
    whitebox: true,
    draggable: true,
    title: 2224,
    titleHelp: context.isCustomerUser ? 1942 : undefined,
    groupCss: null,
    allowAdd: true,
    allowDelete: true,
    groupField: 'IsExtra',
    fields: [
      {
        name: 'Name',
        header: context.isCustomerList ? 1203 : undefined,
        type: 'text',
        editable: false,
        hide: false,
        css: 'taskName' + (context.isCustomerList && context.department !== 1 ? 'Customer' : ''),
        col: 3
      },
      {
        name: 'Price',
        header: context.isCustomerList ? 641 : undefined,
        type: 'currency',
        editable: false,
        hide: false,
        css: 'price' + (context.isCustomerList && context.department !== 1 ? 'Customer' : '')
      },
      ...(context.department === 0 && [
        {
          name: 'Discount',
          header: context.isCustomerList ? 1199 : undefined,
          type: 'percent',
          editable: true,
          hide: !context.isCustomerList,
          css: 'discount' + (context.isCustomerList ? 'Customer' : '')
        },
        {
          name: 'Net',
          header: context.isCustomerList ? 1305 : undefined,
          type: 'currency',
          editable: true,
          hide: !context.isCustomerList,
          css: 'net' + (context.isCustomerList ? 'Customer' : '')
        }
      ])
    ],
    newItemInputs: context.isCustomerList ? ['Name', 'Price', 'Discount', 'Net'] : ['Name', 'Price']
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Prices/Extras/config.js